'use client';

import { IAPIPathPrefixed } from 'my-poppies-b2b-types';
import { useCallback, useContext } from 'react';

// eslint-disable-next-line no-restricted-imports
import { callApi as callApiOriginal, ICallApiFn } from '@/api/callApi';
import { IApiConfig } from '@/api/IAPIConfig';
import { IApiFnMocked } from '@/api/IApiFnMocked';
import { IAPIMethod } from '@/api/IAPIMethod';
import { AuthContext } from '@/contexts/AuthContext';
import { GlobalStateContext } from '@/contexts/GlobalStateContext';

export const useApi = () => {
  const { logout } = useContext(AuthContext);
  const { mockApi } = useContext(GlobalStateContext);

  const callApi: ICallApiFn = useCallback(
    (method: IAPIMethod, path: IAPIPathPrefixed, config: IApiConfig, mockFn: IApiFnMocked) => {
      // @ts-expect-error additional param throws it off
      return callApiOriginal(method, path, config, mockFn, logout, mockApi);
    },
    [logout, mockApi]
  );

  return {
    callApi,
  };
};
